export class BaseGame {
    shouldPlay: boolean = true;
}
